import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import * as Types from '../../../../types/api.types.generated.d';
import { JobOrderFragmentFragmentDoc } from '../fragments/jobOrder.fragment.generated';

const defaultOptions = {} as const;
export type HubJobOrderQueryVariables = Types.Exact<{
  jobOrderId: Types.Scalars['String']['input'];
}>;

export type HubJobOrderQuery = {
  __typename?: 'Query';
  jobOrder: {
    __typename?: 'JobOrderHubType';
    jobOrderId: string;
    customId: number;
    jobOrderLabel: string;
    clientName?: string | null;
    seniority?: Types.SeniorityLevelEnum | null;
    experienceYears?: number | null;
    description?: string | null;
    dateStart1?: any | null;
    dateStart2?: any | null;
    dateEnd?: any | null;
    locationPreference?: string | null;
    minEnglishLevel?: Types.LanguageLevelEnum | null;
    workMode?: Types.WorkModeEnum | null;
    rateRangeTo?: number | null;
    rateRangeFrom?: number | null;
    isEnglish?: boolean | null;
    maxAvailability?: Types.MaxAvailabilityEnum | null;
    createdAt: any;
    assignmentDate?: any | null;
    isChubVisible: boolean;
    leadingTechnology?: string | null;
    isJobPositionStrictlyRequired: boolean;
    isSaved?: boolean | null;
    isAIRAvailable: boolean;
    isOnlyAir: boolean;
    skillsMustHave: Array<{
      __typename?: 'ExpertTagType';
      id: string;
      name: string;
      weight: number;
    }>;
    skillsNiceToHave: Array<{ __typename?: 'ExpertTagType'; id: string; name: string }>;
    owner?: { __typename?: 'UserHubType'; email: string; name: string } | null;
    assignees: Array<{
      __typename?: 'JobOrderAssigneesParamsType';
      brm?: string | null;
      talentAdvocates?: Array<string> | null;
    }>;
    application?: {
      __typename?: 'JobOrderApplicationHubType';
      applicationId: string;
      jobOrderId: string;
      publicOfferId?: string | null;
      createdAt: string;
      meetingDates: Array<string>;
      ciDate?: string | null;
      cqDate?: string | null;
      status: Types.JobOrderApplicationStatusEnum;
      processStatus: Types.JobOrderApplicationProcessStatusEnum;
      prevProcessStatus?: Types.JobOrderApplicationProcessStatusEnum | null;
      meetingUrl?: string | null;
      isViewedByExpert: boolean;
      handlerId?: string | null;
      preppingId?: string | null;
      flow?: Types.JobOrderApplicationFlowEnum | null;
      contactByPhone?: boolean | null;
      isPreferencesFinished: boolean;
      hasActiveAirInterviewInvitation: boolean;
      preferences?: {
        __typename?: 'JobOrderApplicationPreferencesType';
        location?: string | null;
        workType?: Types.WorkModeEnum | null;
        rateDesired?: number | null;
        linkedInUrl?: string | null;
        availability?: Types.ExpertAvailabilityEnum | null;
        noticeLength?: number | null;
        experienceYears?: number | null;
        englishLevel?: Types.LanguageLevelEnum | null;
        skillsMustHave?: Array<{
          __typename?: 'PreferencesSkillType';
          tagId: string;
          weight: number;
        }> | null;
        skillsNiceToHave?: Array<{
          __typename?: 'PreferencesSkillType';
          tagId: string;
          weight: number;
        }> | null;
      } | null;
    } | null;
  };
};

export const HubJobOrderDocument = gql`
  query hubJobOrder($jobOrderId: String!) {
    jobOrder(jobOrderId: $jobOrderId) {
      ...JobOrderFragment
    }
  }
  ${JobOrderFragmentFragmentDoc}
`;

/**
 * __useHubJobOrderQuery__
 *
 * To run a query within a React component, call `useHubJobOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useHubJobOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHubJobOrderQuery({
 *   variables: {
 *      jobOrderId: // value for 'jobOrderId'
 *   },
 * });
 */
export function useHubJobOrderQuery(
  baseOptions: Apollo.QueryHookOptions<HubJobOrderQuery, HubJobOrderQueryVariables> &
    ({ variables: HubJobOrderQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<HubJobOrderQuery, HubJobOrderQueryVariables>(HubJobOrderDocument, options);
}
export function useHubJobOrderLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<HubJobOrderQuery, HubJobOrderQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<HubJobOrderQuery, HubJobOrderQueryVariables>(
    HubJobOrderDocument,
    options,
  );
}
export function useHubJobOrderSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<HubJobOrderQuery, HubJobOrderQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<HubJobOrderQuery, HubJobOrderQueryVariables>(
    HubJobOrderDocument,
    options,
  );
}
export type HubJobOrderQueryHookResult = ReturnType<typeof useHubJobOrderQuery>;
export type HubJobOrderLazyQueryHookResult = ReturnType<typeof useHubJobOrderLazyQuery>;
export type HubJobOrderSuspenseQueryHookResult = ReturnType<typeof useHubJobOrderSuspenseQuery>;
export type HubJobOrderQueryResult = Apollo.QueryResult<
  HubJobOrderQuery,
  HubJobOrderQueryVariables
>;
export function refetchHubJobOrderQuery(variables: HubJobOrderQueryVariables) {
  return { query: HubJobOrderDocument, variables };
}
